import { Link } from "@tanstack/react-router"
import { cn } from "@/utils/styles.helpers"
import { LiveCountBadge } from "./live-count-badge"
import type { NavLocation } from "./nav-model"

/**
 * The tabs of the current page, drawn inside the header row. The active tab
 * is underlined on the header's bottom border.
 */
export function NavTabs({ match }: { match: NavLocation }) {
	return (
		<nav
			aria-label={`${match.page.title} tabs`}
			className="flex h-12 min-w-0 items-stretch gap-4 overflow-x-auto"
		>
			{match.page.tabs.map((tab) => {
				const active = tab.href === match.tab.href

				return (
					<Link
						key={tab.href}
						to={tab.href}
						aria-current={active ? "page" : undefined}
						className={cn(
							"-mb-px flex shrink-0 items-center gap-1.5 whitespace-nowrap border-b-2 text-sm transition-colors",
							active
								? "border-marker font-medium text-foreground"
								: "border-transparent text-muted-foreground hover:text-foreground",
						)}
					>
						{tab.title}
						{tab.liveBadge && <LiveCountBadge kind={tab.liveBadge} />}
					</Link>
				)
			})}
		</nav>
	)
}
